import { render, staticRenderFns } from "./Shablon.vue?vue&type=template&id=09722101&scoped=true&"
import script from "./Shablon.vue?vue&type=script&lang=js&"
export * from "./Shablon.vue?vue&type=script&lang=js&"
import style0 from "./Shablon.vue?vue&type=style&index=0&id=09722101&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09722101",
  null
  
)

export default component.exports